<template>
    <b-container fluid class="no-padding bottom-padding">
        <canvas ref='drawdownCanvas' :renderingKey='renderingKey' :width='canvasWidth' :height='canvasHeight'/>
    </b-container>
</template>

<script>

import draftEditorService from '../mixins/draftEditorService.js'

export default {
    props: {
        columnsCount: {
            type: Number,
            required: true
        },
        rowsCount: {
            type: Number,
            required: true
        },
        drawdownArray: {  // true if warp thread is up, false if weft thread is up
            type: Array,
            required: true
        },
        warpThreads: {
            type: Array,
            required: true
        },
        weftThreads: {
            type: Array,
            required: true
        },
        cellPixelSize: {
            type: Number,
            required: true
        },
        borderThicknessPixels: {
            type: Number,
            required: true
        },
        renderingKey: {
            type: String,
            required: true
        },
        showDividingLines: {
            type: Boolean,
            required: true
        },
        showReverseSide: {
            type: Boolean,
            required: true
        }
    },
    mixins: [draftEditorService],
    components: {

    },
    data() {
        return {
            vueCanvas: null
        }
    },
    methods: {
        drawGroundAndPatternWeaves() {
            // console.log('drawGroundAndPatternWeaves 0')
            if (this.drawdownArray && this.drawdownArray.length > 0) {
            //     console.log('drawGroundAndPatternWeaves 2')
                this.renderDrawdown(this.vueCanvas, this.drawdownArray, this.weftThreads, true, true, this.showReverseSide)
            }
        }
    },

    watch: {
    },
    computed: {
        canvasWidth: function() {
            return (this.columnsCount * this.cellPixelSize) + ((this.columnsCount+1) * (this.borderThicknessPixels))
        },
        canvasHeight: function() {
            return (this.rowsCount * this.cellPixelSize) + ((this.rowsCount+1) * (this.borderThicknessPixels))
        }
    },
    created() {
        // console.log('in drawdownGrid created')
    },
    mounted() {
        // console.log('in drawdownGrid mounted')
        let c = this.$refs['drawdownCanvas']
        let ctx = c.getContext('2d')
        this.vueCanvas = ctx
        this.drawGroundAndPatternWeaves()
    },
    updated() {
        // console.log('in drawdownGrid updated')
        this.drawGroundAndPatternWeaves()
    }
}
</script>

<style scoped>
input[type=file] {
    cursor: pointer; 
}
</style>



// WEBPACK FOOTER //
// src/components/DrawdownGrid.vue